import React, { FC, useEffect, useState } from 'react';
import { connect } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import { injectScript } from 'app/lib/domUtils';
import { selectLiveStreamPreferences } from 'app/modules/LiveStream/selectors';

import styles from './TwitchHandler.module.scss';

type TwitchHandlerProps = {
  videoId: string;
} & ReturnType<typeof mapStateToProps>;

const TWITCH_PLAYER_URL = 'https://player.twitch.tv/js/embed/v1.js';

const createTwitchPlayer = (channel: string, muted: boolean) => {
  const options = {
    height: '100%',
    width: '100%',
    controls: false,
    autoplay: true,
    channel,
    muted,
  };

  return new window.Twitch.Player('twitch-player', options); // встраивает twitch player в узел с id twitch-player
};

const TwitchHandler: FC<TwitchHandlerProps> = ({
  videoId,
  muted,
}) => {
  const [player, setPlayer] = useState<typeof window.Twitch.Player>(null);

  useEffect(() => {
    player && player.destroy();

    if (window.Twitch && window.Twitch.Player) {
      setPlayer(createTwitchPlayer(videoId, muted));
      return;
    }

    injectScript(TWITCH_PLAYER_URL)
      .then(() => setPlayer(createTwitchPlayer(videoId, muted)));
  }, [videoId]);

  useEffect(() => {
    if (player) {
      player.setMuted(muted);
    }
  }, [muted]);

  return (
    <div id="twitch-player"                            // twitch встраивается по данному id
         className={styles.twitchContainer} />
  );
};

const mapStateToProps = (state: ReduxState) => ({
  muted: selectLiveStreamPreferences(state).muted,
});

export default connect(mapStateToProps)(TwitchHandler);
